import { OptionDescription } from './option.type';
import { EBuyerPropertyType, EBuyerType } from '../enums/buyer.enum';

export type BuyerTypeRecord = Record<EBuyerType, OptionDescription<EBuyerType>>;
export type BuyerPropertyTypeRecord = Record<EBuyerPropertyType, OptionDescription<EBuyerPropertyType>>;
